define('bindingHandlers/clearInput',[
    'jquery',
    'lib/lodash4',
    'lib/knockout'
], function(
    $,
    _,
    ko
){
    "use strict";

    var EVENT_MOUSE_ENTER = 'mouseenter',
        EVENT_MOUSE_LEAVE = 'mouseleave',
        EVENT_MOUSE_DOWN  = 'mousedown',
        EVENT_FOCUS_IN    = 'focusin',
        EVENT_FOCUS_OUT   = 'focusout',
        EVENT_CLICK       = 'click',
        EVENT_KEYDOWN     = 'keydown',

        DEFAULT_OPTIONS = {
            focusAfterClear : true,
            callBack        : _.noop,
            wrapperClass    : 'clear-input-wrapper',
            btnClass        : 'clear-input-btn fa fa-times-circle'
        },

        EVENT_NAMESPACE = '.clearInput',

        SPACES_REGEXP   = /^\s+|\s+$/g,

        TOKEN        = '{0}',
        WRAPPER_HTML = '<div class="{0}">{0}</div>',
        LNK_BTN_HTML = '<a href="#" class="{0}"><span class="sr-only">{0}</span></a>';

    /**
     * Adds a clear button to any input on which it is bound.  Clears the input on click and then refocuses on the cleared
     * input by default.
     *
     *
     * @type {{init: init}}
     */
    ko.bindingHandlers.clearInput = {
        init : function(input, valueAccessor, allBindings ){
            var $input        = $(input),
                value         = ko.unwrap(valueAccessor()) || {},
                options       = _.defaults(value, DEFAULT_OPTIONS),

                focusAfter    = options.focusAfterClear,
                callback      = options.callBack,
                wrapperClass  = options.wrapperClass,
                btnClass      = options.btnClass,

                $clearBtn,

                wrapInput = function(){
                    $input.after(
                        WRAPPER_HTML
                            .replace(TOKEN, wrapperClass)
                            .replace(TOKEN, $input.html())
                    );
                    $input.next().append(
                        LNK_BTN_HTML
                            .replace(TOKEN,btnClass)
                            .replace(TOKEN, ko.i18n.renderString('widget.clearInput.screenreader'))
                    );
                    return $input.next().find('a');
                },

                updateButtonPosition = function() {
                    var height = $input.outerHeight(true),
                        buttonWidth = $clearBtn.outerWidth(true) || 20,
                        buttonHeight = $clearBtn.outerHeight(true) || 20;

                    $clearBtn.css('top', height/2- buttonHeight/2 );
                    $clearBtn.css('left', -buttonWidth/2 );
                },

                hasValues = function(){
                    SPACES_REGEXP.lastIndex = 0;
                    return $input.val().replace(SPACES_REGEXP, '').length > 0;
                },

                showClearIfPossible = function () {
                    if (hasValues()){
                        updateButtonPosition();
                        $clearBtn.show();
                    }
                },

                hideClear = function(){
                    $clearBtn.hide();
                },

                handleClearInput = function(event){
                    $input.val('').change();
                    if (focusAfter) {
                        $input.focus();
                    }
                    callback.apply();
                    $clearBtn.hide();
                    event.preventDefault();
                },

                bindingContext    = ko.unwrap(allBindings()),
                valueBinding      = ko.isObservable(bindingContext.value) ? bindingContext.value : null,
                valueSubscription = valueBinding ? valueBinding.subscribe(showClearIfPossible) : null,

                clearSubscriptions = function (){
                    if (valueSubscription){
                        valueSubscription.dispose();
                    }
                };

            $clearBtn = wrapInput();

            hideClear();
            updateButtonPosition();

            $clearBtn
                .on(EVENT_CLICK       + EVENT_NAMESPACE, handleClearInput)
                .on(EVENT_MOUSE_DOWN  + EVENT_NAMESPACE, handleClearInput)
                .on(EVENT_MOUSE_ENTER + EVENT_NAMESPACE, showClearIfPossible);

            $input.parent()
                .on(EVENT_FOCUS_IN    + EVENT_NAMESPACE, showClearIfPossible)
                .on(EVENT_KEYDOWN     + EVENT_NAMESPACE, showClearIfPossible)
                .on(EVENT_MOUSE_ENTER + EVENT_NAMESPACE, showClearIfPossible)
                .on(EVENT_FOCUS_OUT   + EVENT_NAMESPACE, hideClear)
                .on(EVENT_MOUSE_LEAVE + EVENT_NAMESPACE, hideClear);

            ko.utils.domNodeDisposal.addDisposeCallback( input, function () {
                $input.off(EVENT_NAMESPACE);
                $clearBtn.off(EVENT_NAMESPACE);
                clearSubscriptions();
            });

        }
    };
});

